import type { FC } from 'react';
import { MapWrapper } from './Map.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface MapProps { }

const MapCollection: FC<MapProps> = () => (
   <MapWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Map</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <p className="text-align-justify">
            The map enables us to store data in key-value pairs (keys should be immutable). A map in java cannot contain duplicate keys; each key can map to at most one value. The Map interface consists of three collection views, a set of keys, a collection of values, or a set of key-value mappings.
            <br />Eg :
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
               {
                  'Map <String, Integer> map = new HashMap <String, Integer> ();\n'+
                  'map.put("a", new Integer(100));'
               }
            </SyntaxHighlighter>
         </p>
         <br/>
         <p  className="text-align-justify">Types of Map :</p>
         <ul  className="text-align-justify">
            <li><strong>HashMap :</strong>
               <ul>
                  <li>It is the implementation of Map.</li>
                  <li>It doesn’t maintain any order.</li>
                  <li>It allows null keys and values.</li>
                  <li>Eg :
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'HashMap cities = new HashMap();\n'+
                           'cities.put("England", "London");'
                        }
                     </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
            <br/>
            <li><strong>HashTable :</strong>
               <ul>
                  <li>Hashtable implements the Map interface.</li>
                  <li>It is the same as HashMap but is synchronized.</li>
                  <li>Similar to HashMap, Hashtable stores key/value pairs in a hash table.</li>
                  <li>The key in hashtable is then hashed, which results in a hash code. This code is then used as the index at which the value is stored within the table.</li>
                  <li>Eg :
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'Hashtable table = new Hashtable();\n'+
                           'table.put("One", new Double(3434.34));'
                        }
                     </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
            <br/>
            <li><strong>LinkedHashMap :</strong>
               <ul>
                  <li>LinkedHashMap is the implementation of Map.</li>
                  <li>It inherits the HashMap class.</li>
                  <li>It maintains insertion order.</li>
                  <li>It allows null keys and values.</li>
                  <li>Eg :
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'LinkedHashMap lhm = new LinkedHashMap();\n'+
                           'lhm.put("one", "two");'
                        }
                     </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
            <br/>
            <li><strong>TreeMap :</strong>
               <ul>
                  <li>TreeMap is the implementation of Map and SortedMap.</li>
                  <li>It maintains ascending order.</li>
                  <li>It doesn’t allow null keys and values.</li>
                  <li>E.g. :
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'TreeMap treemap = new TreeMap();\n'+
                           'treemap.put(10, "One");'
                        }
                     </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
         </ul>
      </div>
   </MapWrapper>
);

export default MapCollection;
